<template>
    <div class="clients">
        <!-- Cabeçalho -->
        <header class="clients-header">
            <div></div>      
            <!-- Botão para alternar entre tabela e kanban -->
            <el-button @click="handleModalFormClient()" type="success" icon="Plus">
                Categoria
            </el-button>
        </header>
        <!-- Tabela de Tarefas -->
        <el-table :data="categories" style="width: 100%" v-loading="loading">
            <el-table-column prop="name" label="Categoria" />                
            <el-table-column label="Status">
                <template #default="{ row }">
                  <StatusGeneral :status="row.active" />
                </template>
            </el-table-column>       
            <el-table-column label="Ações">
              <template #default="scope">
                <el-button
                  icon="Edit"
                  plain
                  type="success"
                  @click="editClient(scope.row)" />
                <el-button                  
                  type="danger" 
                  plain
                  icon="Delete"
                  @click="deleteData(scope.row)" />
              </template>
            </el-table-column>
          </el-table>     
          
          <el-dialog v-model="isModalVisible" :title="titleModal">
              <el-form label-position="top" :model="dataForm">
    
                  <el-input hidden v-model="dataForm.id" />                  
    
                  <el-form-item label="Categoria">
                      <el-input v-model="dataForm.name" />
                  </el-form-item>
    
                  <el-form-item label="Status">                  
                    <el-select v-model="dataForm.active" placeholder="Selecione o Status">
                        <el-option label="Ativo" value="1" />
                        <el-option label="Inativo" value="0" />
                    </el-select>
                  </el-form-item>              
              </el-form>
              <div>
                  <el-button @click="isModalVisible = false">Cancelar</el-button>
                  <el-button type="primary" @click="saveData()">Salvar</el-button>
              </div>
          </el-dialog>    
    </div>
</template>
<script>
import { ElMessageBox, ElNotification } from 'element-plus';
import { deleteCategory, getCategories, storeCategory, updateCategory } from '@/services/clientService';
import StatusGeneral from '@/components/StatusGeneral';

export default {
    name: "TaskCategorieComponent",
    components: {
        StatusGeneral
    },
    data() {
        return {
            urlApi: process.env.VUE_APP_API_URL,
            categories: [],
            dataForm: {
                id: null,
                name: '',
                active: ''
            },
            loading: false,
            isModalVisible: false,
            titleModal: 'Cadastrar Categoria',
            actionForm: 'create'
        };
    },    
    methods: {
        async getData() {
            this.loading = true;
            try {
                const response = await getCategories();                

                this.categories = response.data;
            } catch (error) {
                this.$message.error("Erro ao carregar categorias de tarefas.");
            } finally {
                this.loading = false;
            }
        },
        handleModalFormClient() {            
            this.isModalVisible = true;
            this.actionForm = 'create';
        },
        editClient(client) {
            this.dataForm = {
                id: client.id,
                name: client.name,
                active: String(client.active)
            }

            this.titleModal = 'Atualizar Categoria';
            this.handleModalFormClient();
            this.actionForm = 'update';
        },

        async saveData() {
            this.loading = true;
            this.errors = {};
            try {
                if (this.actionForm == 'create') {
                    await storeCategory(this.dataForm);

                    ElNotification({
                        title: 'Atenção!',
                        message: 'Registro criado com sucesso.',
                        type: 'success'
                    });
                }

                if (this.actionForm == 'update') {
                    await updateCategory(this.dataForm);
                    ElNotification({
                        title: 'Atenção!',
                        message: 'Registro salvo com sucesso.',
                        type: 'success'
                    });
                }

                
                
            } catch (error) {
                console.log('error ===> ', error)
                if (error.errors) {
                    const errors = error.errors;
                    const errorMessages = Object.values(errors)
                        .flat()
                        .join('\n');

                        ElNotification({
                            title: 'Erro de Validação',
                            message: errorMessages,
                            dangerouslyUseHTMLString: true,
                            type: 'error',
                        });
                } else {
                    ElNotification({
                        title: 'Erro!',
                        message: 'Ocorreu um erro inesperado ao processar a solicitação.',
                        type: 'error',
                    });
                }

            } finally {
                this.resetForm();
                this.getData();

                this.isModalVisible = false;
                this.loading = false;
            }
        },

        async deleteData(category){

            await ElMessageBox.confirm(
                'Deseja realmente deletar a categoria: '+ category.name +'?',
                'Warning',
                {
                    confirmButtonText: 'Confirmar Exclusão',
                    cancelButtonText: 'Cancelar',
                    type: 'warning',
                }
            )
            .then(() => {
                this.loading = true;
                
                deleteCategory(category.id);                                
                this.getData();
                ElNotification({
                    title: 'Atenção!',
                    message: 'Registro deletado com sucesso.',
                    type: 'success'
                });

            })
            .catch(() => {
                
            });

            this.getData();
            this.loading = false;
        },

        resetForm() {
            this.dataForm = {
                id: null,
                name: '',
                active: '1'            
            }
        }
    },
    mounted() {
        this.getData();  
    },
};
</script>

<style scoped>
.clients-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 20px;
}
.clients-header h2 {
    font-size: 24px;
    margin: 0;
}
.notification-icon {
    cursor: pointer;
}
</style>
    